// eslint-disable-next-line import/no-anonymous-default-export
export default [
  {
    id: 1,
    imgSrc: require('../design/design1.png'),
  },
  {
    id: 2,
    imgSrc: require('../design/design2.png'),
  },
  {
    id: 3,
    imgSrc: require('../design/design3.png'),
  },
  {
    id: 4,
    imgSrc: require('../design/design4.png'),
  },
  {
    id: 5,
    imgSrc: require('../design/design45.png'),
  },
  {
    id: 6,
    imgSrc: require('../design/design46.png'),
  },
  {
    id: 7,
    imgSrc: require('../design/design47.png'),
  },
  {
    id: 8,
    imgSrc: require('../design/design54.png'),
  },
  {
    id: 9,
    imgSrc: require('../design/design50.png'),
  },
  // {
  //   id: 10,
  //   imgSrc: require('../design/design44.png'),
  // },
  {
    id: 11,
    imgSrc: require('../design/design55.png'),
  },
  {
    id: 12,
    imgSrc: require('../design/design52.png'),
  },
  {
    id: 13,
    imgSrc: require('../design/design53.png'),
  },
  {
    id: 14,
    imgSrc: require('../design/design49.png'),
  },
  {
    id: 15,
    imgSrc: require('../design/design56.png'),
  },
  {
    id: 16,
    imgSrc: require('../design/design8.png'),
  },
  {
    id: 17,
    imgSrc: require('../design/design57.png'),
  },
  {
    id: 18,
    imgSrc: require('../design/design41.png'),
  },
  {
    id: 19,
    imgSrc: require('../design/design19.png'),
  },
  {
    id: 20,
    imgSrc: require('../design/design20.png'),
  },
  {
    id: 21,
    imgSrc: require('../design/design21.png'),
  },
  {
    id: 22,
    imgSrc: require('../design/design22.png'),
  },
  {
    id: 23,
    imgSrc: require('../design/design23.png'),
  },
  {
    id: 24,
    imgSrc: require('../design/design24.png'),
  },
  {
    id: 25,
    imgSrc: require('../design/design25.png'),
  },
  {
    id: 26,
    imgSrc: require('../design/design26.png'),
  },
  {
    id: 27,
    imgSrc: require('../design/design27.png'),
  },
  {
    id: 28,
    imgSrc: require('../design/design28.png'),
  },
  {
    id: 29,
    imgSrc: require('../design/design29.png'),
  },
  {
    id: 30,
    imgSrc: require('../design/design30.png'),
  },
  {
    id: 31,
    imgSrc: require('../design/design31.png'),
  },
  {
    id: 32,
    imgSrc: require('../design/design32.png'),
  },
  {
    id: 33,
    imgSrc: require('../design/design33.png'),
  },
  {
    id: 34,
    imgSrc: require('../design/design34.png'),
  },
  {
    id: 35,
    imgSrc: require('../design/design35.png'),
  },
  {
    id: 36,
    imgSrc: require('../design/design36.png'),
  },
  {
    id: 37,
    imgSrc: require('../design/design37.png'),
  },
  {
    id: 38,
    imgSrc: require('../design/design38.png'),
  },
  {
    id: 39,
    imgSrc: require('../design/design39.png'),
  },
  {
    id: 40,
    imgSrc: require('../design/design40.png'),
  },
  {
    id: 41,
    imgSrc: require('../design/design18.png'),
  },
  {
    id: 42,
    imgSrc: require('../design/design5.png'),
  },
  {
    id: 43,
    imgSrc: require('../design/design6.png'),
  },
  {
    id: 44,
    imgSrc: require('../design/design7.png'),
  },
  {
    id: 45,
    imgSrc: require('../design/design12.png'),
  },
  {
    id: 46,
    imgSrc: require('../design/design51.png'),
  },
  {
    id: 47,
    imgSrc: require('../design/design15.png'),
  },
  {
    id: 48,
    imgSrc: require('../design/design10.png'),
  },
  {
    id: 49,
    imgSrc: require('../design/design13.png'),
  },
  {
    id: 50,
    imgSrc: require('../design/design48.png'),
  },
  {
    id: 51,
    imgSrc: require('../design/design17.png'),
  },
]
